import clsx from "clsx";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { BRANDS } from "@/enums/brands";
import { THEME } from "@/enums/profile";
import { GetBackgroundColor, GetFontColors } from "@/utils/library/color";
import BrandImage from "../common/BrandImage";

const AskChatBubble: React.FC<{
  children?: React.ReactNode;
  isUser?: boolean;
  isWelcomeMessage?: boolean;
  agentName?: string;
  themeOverride?: THEME;
  brandOverride?: BRANDS;
  className?: string;
  isForm?: boolean;
}> = ({
  children,
  isUser,
  isWelcomeMessage,
  agentName,
  themeOverride,
  brandOverride,
  className,
  isForm = false,
}) => {
  const { t } = useTranslation("ask");
  const [bubbleColors, setBubbleColors] = React.useState<{
    background: string;
    font: string;
  }>({
    background: "#eee",
    font: "#000",
  });

  useEffect(() => {
    const color = GetBackgroundColor(brandOverride);
    const fontColors = color
      ? GetFontColors({ primary: color.primary, secondary: color.primary })
      : { primary: "#000", secondary: "#000" };

    setBubbleColors({
      background: color?.primary || "#eee",
      font: fontColors.primary,
    });
  }, [themeOverride, brandOverride]);

  return (
    <div
      className={clsx(
        "rounded-lg",
        "max-w-[90%]",
        "text-sm",
        "monument-font",
        "mb-4",
        { "inline-block": !isForm },
        { "w-full sm:w-3/4 md:w-2/3": isForm },
        className,
        {
          "ml-auto px-3 py-2": isUser,
        }
      )}
      style={{
        backgroundColor: !!isUser ? bubbleColors.background : undefined,
        color: !!isUser ? bubbleColors.font : undefined,
      }}
    >
      {!isUser && !isWelcomeMessage && (
        <div className="mb-2">
          <BrandImage
            brand={brandOverride ?? BRANDS.GAIL}
            className="inline"
            height={16}
            variant="small"
          />
          <span className={clsx("font-semibold", "ml-2", "text-sm")}>
            &bull;
            {agentName
              ? ` ${agentName}`
              : ` ${t(brandOverride ?? BRANDS.GAIL)} ${t("agent")}`}
          </span>
        </div>
      )}
      {children}
      {!children && (
        <div className="text-sm leading-relaxed">
          <span className="inline-block animate-pulse">▋</span>
        </div>
      )}
    </div>
  );
};

export default AskChatBubble;
